module.exports = __webpack_public_path__ + "autopilot-robot-a58936a6b64b431c53fd21c5a2ddd9ef.svg";